import React from "react";
import { BadgeCheck } from "lucide-react";

// REACT_APP_BUILD_DATE lo fija craco.config.js en cada build.
const BUILD_DATE = process.env.REACT_APP_BUILD_DATE ? new Date(process.env.REACT_APP_BUILD_DATE) : null;
export const LAST_UPDATED = BUILD_DATE && !isNaN(BUILD_DATE)
  ? new Intl.DateTimeFormat("es-ES", { day: "numeric", month: "long", year: "numeric", timeZone: "Europe/Madrid" }).format(BUILD_DATE)
  : "11 de agosto de 2026";

export const AuthorityNote = () => (
  <div className="mt-8 rounded-2xl bg-[var(--faro-bg)] border border-[rgba(30,42,143,0.12)] p-4 sm:p-5 flex items-start gap-3" data-testid="authority-note">
    <BadgeCheck size={20} className="text-[var(--faro-red)] shrink-0 mt-0.5" />
    <div className="text-sm text-[var(--faro-text-soft)] leading-relaxed">
      <strong className="text-[var(--faro-text)]">Centro autorizado por la DGT</strong> para impartir cursos de sensibilización y
      reeducación vial. Contenidos conformes a la <strong>Orden INT/914/2024</strong>, en vigor desde el 4 de noviembre de 2024
      (curso parcial de 10 h con recuperación de hasta 4 puntos; curso total de 20 h).
      <span className="block mt-1 text-xs">Última actualización: {LAST_UPDATED}</span>
    </div>
  </div>
);
